import React from 'react';
import { Lock } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';

const PhoneScreen = ({ isLocked, timeRemaining, password, setPassword, handleUnlock, apps, t, formatTime }) => {
  return (
    <div className="mx-auto w-full max-w-xs">
      <div className="bg-black rounded-3xl p-6 shadow-2xl border-8 border-gray-800 relative" style={{ aspectRatio: '9/19' }}>
        {/* Lock Overlay */}
        {isLocked && (
          <div className="absolute inset-0 bg-black/90 backdrop-blur-sm rounded-2xl z-10 flex flex-col items-center justify-center p-6">
            <Lock className="w-16 h-16 text-white mb-4 animate-pulse" />
            <h3 className="text-white text-2xl font-light mb-2">{t('minimalMode')}</h3>
            <p className="text-gray-400 text-sm text-center mb-6">{t('focusTimeRemaining')}</p>
            <div className="text-white text-5xl font-light mb-8">
              {formatTime(timeRemaining)}
            </div>
            <div className="w-full space-y-3">
              <Input
                type="password"
                placeholder={t('enterPasswordUnlock')}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-gray-800 border-gray-700 text-white placeholder:text-gray-500"
                onKeyDown={(e) => e.key === 'Enter' && handleUnlock()}
              />
              <Button 
                onClick={handleUnlock}
                className="w-full bg-white text-black hover:bg-gray-200"
              >
                {t('unlockEarly')}
              </Button>
            </div>
            <p className="text-gray-500 text-xs mt-4 text-center">{t('unlockWarning')}</p>
          </div>
        )}

        {/* Normal Phone Interface */}
        <div className="text-white">
          <div className="text-center mb-8">
            <div className="text-5xl font-light mb-2">15:07</div>
            <div className="text-sm opacity-70">Tuesday, 26th May</div>
          </div>
          
          <div className="space-y-3">
            {apps.map((app) => (
              <div 
                key={app}
                className="text-center py-3 border-b border-gray-700 hover:bg-gray-800 transition-colors rounded cursor-pointer"
              >
                {app}
              </div>
            ))}
          </div>

          {!isLocked && (
            <div className="mt-6 pt-6 border-t border-gray-700">
              <Button 
                onClick={() => {}}
                className="w-full bg-white text-black hover:bg-gray-200 flex items-center justify-center space-x-2 rtl:space-x-reverse"
              >
                <Lock className="w-4 h-4" />
                <span>{t('lockToMinimal')}</span>
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PhoneScreen;
